module.exports = __webpack_public_path__ + "static/media/Double-Nine.6209b1a7.png";